import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  label: FooterLabel_EN;

  constructor(public dialogRef: MatDialogRef<TermsAndConditionsComponent>) { }

  ngOnInit() {
    this.label = new FooterLabel_EN();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
